import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, Box, Link, makeStyles, Typography } from "@material-ui/core";
import { useTenantImage } from "@ploy-ui/tenants";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { MarkdownElement } from "@ploy-ui/core";
addRegisteredSectionLayout({
    name: "FrendeInsuranceSection",
    displayName: "FrendeInsuranceSection",
    settings: {}
});
const useStyles = makeStyles((theme) => ({
    informationImage: {
        backgroundImage: `url(${useTenantImage("FrendeInsuranceImage")})`,
        backgroundSize: "cover",
        backgroundPosition: "50%",
        maxWidth: "12rem",
        minHeight: "15rem",
        flex: "1 1"
    },
    informationSpan: {
        display: "flex"
    },
    informationText: {
        padding: "12px",
        flex: "1 1"
    },
    outerDiv: {
        border: "1px solid #ababab"
    },
    summaryAaccordion: {
        "&.Mui-expanded": {
            margin: "0"
        }
    },
    summaryCollapsed: {
        "&.Mui-expanded": {
            minHeight: 0
        },
        "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: "auto"
        }
    },
    summaryDetails: {
        display: "block",
        padding: "0"
    },
    summaryFooter: {
        backgroundColor: "#ddd",
        paddingTop: "1rem",
        paddingBottom: "1rem",
        paddingRight: "2rem",
        paddingLeft: "2rem"
    },
    summaryMainInformation: {
        paddingTop: "0",
        paddingBottom: "0",
        paddingRight: "2rem",
        paddingLeft: "2rem"
    },
    legalFooter: {
        paddingTop: "0",
        paddingBottom: "0",
        paddingRight: "2rem",
        paddingLeft: "0.5rem"
    }
}));
export const FrendeInsuranceSection = (props) => {
    const classes = useStyles();
    const detailList = "- Kaskoforsikring\n- Leiebil i hele reparasjonstiden\n- Utvidet dekning\n- Maskinskade for inntil 10 år gamle biler\n- Batteripakke og elektronisk styringsenhet er også omfattet i maskinskade\n- For elektriske- og hybridbiler er ladekabel inkludert\n- Egenandel 6000 kr";
    return (_jsxs("div", { className: `${props.className} ${classes.outerDiv}`, children: [_jsxs("span", { className: classes.informationSpan, children: [_jsx("div", { className: classes.informationImage }), _jsxs("div", { className: classes.informationText, children: [_jsx(Typography, { variant: "subtitle1", children: _jsx(Box, { sx: { fontWeight: "bold" }, children: "Gi kunden Frendes beste bilforsikring GRATIS 1 m\u00E5ned" }) }), _jsx(Typography, { children: "Frende tilbyr knallgode, prisvinnende vilk\u00E5r, lynrask opptjening av bonus og leiebil i hele reparasjonstiden." })] })] }), _jsxs(Accordion, { className: classes.summaryAaccordion, children: [_jsx(AccordionSummary, { className: classes.summaryCollapsed, children: _jsx(Typography, { children: "Mer informasjon om forsikringen" }) }), _jsxs(AccordionDetails, { className: classes.summaryDetails, children: [_jsxs("div", { className: classes.summaryMainInformation, children: [_jsx(Typography, { variant: "subtitle1", children: _jsx(Box, { sx: { fontWeight: "bold" }, children: "1 m\u00E5ned gratis* bilforsikring fra Frende Forsikring omfatter:" }) }), _jsx(MarkdownElement, { text: detailList })] }), _jsx("div", { className: classes.legalFooter, children: _jsx(Typography, { variant: "subtitle2", children: "* kunden m\u00E5 selv betale trafikkforsikringsavgiften." }) }), _jsxs("div", { className: classes.summaryFooter, children: [_jsx(Typography, { variant: "subtitle1", children: _jsx(Box, { sx: { fontWeight: "bold" }, children: "Lurer du p\u00E5 noe?" }) }), _jsxs(Typography, { children: ["Kontakt Frende p\u00E5 55 15 36 00 eller", " ", _jsx(Link, { href: "mailto:brage.bilforhandler@frende.no", underline: "hover", children: "brage.bilforhandler@frende.no" })] })] })] })] })] }));
};
//# sourceMappingURL=FrendeInsuranceSection.js.map